import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../store/AppContext';
import { menuIdToPath } from './adminRoutes';

export const VIEW_BOOKING_ID_KEY = 'admin-booking-view-id';
export const EDIT_BOOKING_ID_KEY = 'admin-booking-edit-id';

/**
 * Navigate by menu id and keep sidebar state + URL in sync.
 */
export function useAdminNavigate() {
  const navigate = useNavigate();
  const { setActiveMenu } = useUI();

  const goToMenu = useCallback(
    (menuId, params = {}) => {
      if (!menuId) return;

      if (menuId === 'booking-view' && params.bookingId != null) {
        try {
          sessionStorage.setItem(VIEW_BOOKING_ID_KEY, String(params.bookingId));
        } catch {
          /* ignore */
        }
      }
      if (menuId === 'booking-edit' && params.bookingId != null) {
        try {
          sessionStorage.setItem(EDIT_BOOKING_ID_KEY, String(params.bookingId));
        } catch {
          /* ignore */
        }
      }

      const path = menuIdToPath(menuId, params);
      setActiveMenu(menuId);
      navigate(path);
    },
    [navigate, setActiveMenu]
  );

  return { goToMenu, navigate };
}
